import { HttpErrorResponse } from "@angular/common/http";
import { throwError, EMPTY } from "rxjs";

declare var $ : any;

const UNAUTHORIZED : number = 401;
const UnknownError: number = 0;
const BadRequest: number = 400;
const InternalServerError: number = 500;
const NotFound: number = 404;

/** True cuando se ejecutan tests con Karma (evitar que throwError rompa afterAll). */
const isKarma = typeof window !== 'undefined' && !!(window as unknown as { __karma__?: unknown }).__karma__;

export function HandleHttpError(error : HttpErrorResponse){ 
    if(error.status == UNAUTHORIZED){
        if (!isKarma) $('#logOut').click();
        return throwError('Su sesión ha expirado, por favor ingrese nuevamente.');
    }
    if(error.status === UnknownError || error.status === BadRequest || error.status === InternalServerError || error.status === NotFound) {
        if (!isKarma) $('#mantenimiento-error').click();
        if (isKarma) return EMPTY;
        return throwError('Disculpe las molestias nuestro sitio esta actualmente bajo mantenimiento programado agradecemos su compresión.');
    }
    if(error.error){
        return throwError(error.error['message']);
    }
    else{
        return throwError('Upps, algo ha salido mal');
    }
}